import { GameEvent } from '../domain/interfaces/GameDetails';

export const parseGameEventTime = (seconds: number, period: number): { minutes: number, extraMinutes: number } => {
  const periodDuration = 30;

  const eventMinute = Math.floor(seconds / 60);
  const isExtraTime = eventMinute >= period * periodDuration;
  const minutes = isExtraTime ? period * periodDuration : eventMinute;
  const extraMinutes = eventMinute - minutes;

  return {
    minutes,
    extraMinutes,
  };
};

export const sortGameEvents = (events: GameEvent[]): GameEvent[] => {
  return events.sort((a, b) => {
    const order: number = b.minutes - a.minutes;
    if (order) {
      return order;
    }

    const aExtra = a.extraMinutes ? a.extraMinutes : 9999;
    const bExtra = b.extraMinutes ? b.extraMinutes : 9999;

    return aExtra - bExtra;
  });
};